import React, { useState } from "react";
import NormalInput from "../../Components/common/input/NormalInput";
import NormalButton from "../../Components/common/button/NormalButton";
import { FaFilePdf } from "react-icons/fa";
import { checkSaralIdIsExist } from "../../Utils/APIs/checkSaralIdIsExistAPI";
import { downloadFile } from "../../Utils/APIs/downloadFile";
import ddmmyyyy from "../../Utils/date/ddmmyyyy";
import AnimatedButton from "../../Components/common/button/AnimatedButton";
const GeneratePDF = () => {
  const [saralId, setSaralId] = useState(null);
  const [ref, setRef] = useState(null);
  const [generateDate, setGenerateDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [farmerDetails, setFarmerDetails] = useState(null);
  const [farmerExist, setFarmerExist] = useState(null);
  const [ResponseMessage, setResponseMessage] = useState(null);
  const showFarmer = async () => {
    if (saralId === null || saralId.length < 5) {
      alert("please fill valid Saral Id");
    }
    await checkSaralIdIsExist(
      saralId,
      setFarmerDetails,
      setFarmerExist,
      setResponseMessage,
    );
  };
  const generateCoverLetter = async () => {
    if (
      !farmerDetails ||
      !farmerDetails.saralId ||
      !farmerDetails.workOrderDate ||
      !farmerDetails.Order_Ref ||
      !farmerDetails.farmerName ||
      !farmerDetails.district ||
      !ref
    ) {
      alert(" Please provide all required details to generate cover letter.");
      return;
    }
    const data = {
      farmerName: farmerDetails.farmerName,
      saralId: farmerDetails.saralId,
      workOrderDate: farmerDetails.workOrderDate,
      Order_ref: farmerDetails.Order_Ref,
      district: farmerDetails.district,
      generateDate: ddmmyyyy(generateDate),
      ref,
    };
    const api = "/admin/downloadCoverLetter";
    await downloadFile({
      api,
      method: "post",
      data,
    });
  };
  const generateInvoiceLetter = async () => {
    try {
      if (saralId === "" || saralId.length < 4) {
        alert("Please Enter valid saral Id");
        return;
      }
      const api = "/admin/attachSignatureInInvoice";
      const data = {
        saralId,
      };
      await downloadFile({
        api,
        method: "post",
        data,
      });
    } catch (error) {
      alert(error);
    }
  };
  return (
    <div className="flex w-full h-full flex-col">
      <div className="mainHeading">
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg">
          C<span className="text-lg">OVER</span> L
          <span className="text-lg">ETTER</span>
        </h1>
      </div>
      <div className="flex gap-5 justify-center py-5">
        <NormalInput
          label="Saral Id"
          value={saralId}
          setterFun={setSaralId}
          isRequired={true}
          placeholder="Write Saral Id "
        />
        <NormalButton
          btnName="Show Farmer"
          cssClass="h-10 bg-yellow-400 rounded-sm mt-7 px-4"
          onClickFun={showFarmer}
        />
        {farmerDetails && (
          <>
            {" "}
            <NormalInput
              label="Reference No."
              value={ref}
              setterFun={setRef}
              isRequired={true}
              placeholder="Write reference No."
            />
            <NormalInput
              label="Date"
              value={generateDate}
              setterFun={setGenerateDate}
              isRequired={true}
              type="date"
            />
            <AnimatedButton
              icon={<FaFilePdf className="shrink-0" fontSize={24} />}
              txt="Cover Letter"
              onclickFun={generateCoverLetter}
              btnCSS="bg-red-500 text-white hover:w-36"
            />
            <AnimatedButton
              icon={<FaFilePdf className="shrink-0" fontSize={24} />}
              txt="Invoice"
              onclickFun={generateInvoiceLetter}
              btnCSS="bg-green-600 text-white hover:w-28"
            />
          </>
        )}
      </div>
      <div className="flex justify-center items-center w-full">
        {farmerDetails && Object.keys(farmerDetails).length > 0 ? (
          <table className=" table-relative text-center  bg-white border border-gray-300 rounded-lg responsive ">
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left px-6 py-2 text-gray-700 font-semibold">
                Saral Id:
              </th>{" "}
              <td className="text-gray-700">{farmerDetails?.saralId}</td>{" "}
              <th className="text-left px-6 py-2 text-gray-700 font-semibold">
                State :
              </th>
              <td className="text-gray-700">{farmerDetails.state}</td>
              <th className="text-left px-6 py-2 text-gray-700 font-semibold">
                District :
              </th>
              <td className="text-gray-700 px-6 py-2">
                {farmerDetails.district}
              </td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left px-6 py-2 text-gray-700 font-semibold">
                Farmer:
              </th>{" "}
              <td className="text-gray-700">{farmerDetails.farmerName}</td>{" "}
              <th className="text-left px-6 py-2 text-gray-700 font-semibold">
                Work Order Date:
              </th>{" "}
              <td
                className={`text-gray-700 px-6 ${!farmerDetails.workOrderDate ? "bg-red-400 text-white" : ""}`}
              >
                {farmerDetails.workOrderDate || "N/A"}
              </td>{" "}
              <th className="text-left px-6 py-2 text-gray-700 font-semibold">
                Order Reference:
              </th>
              <td
                className={`text-gray-700 px-6 ${!farmerDetails.Order_Ref ? "bg-red-400 text-white" : ""}`}
              >
                {farmerDetails.Order_Ref || "N/A"}
              </td>
            </tr>
          </table>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default GeneratePDF;
